import "./instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { ReactTagManager } from "react-gtm-ts";
import { BrowserRouter } from "react-router-dom";
import { OnboardingProvider } from "./contexts/OnboardingProvider.tsx";
import { ApiProvider } from "./contexts/ApiProvider.tsx";
import { AuthProvider } from "./contexts/AuthProvider.tsx";
import App from "./App.tsx";
import "./i18n";
import "./styles/global.scss";
import appConfig from "./config/app-config.ts";
import ErrorBoundaryFallback from "./components/ErrorBoundaryFallback/index.tsx";
import { captureQueryParams, catureReferrer } from "./utils/queryParams.ts";

// Capture whitelisted query parameters and referrer before React renders
captureQueryParams();
catureReferrer();

if (appConfig.gtmId) {
  ReactTagManager.init({
    code: appConfig.gtmId,
    debug: !import.meta.env.PROD,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <OnboardingProvider>
        <AuthProvider>
          <ApiProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ApiProvider>
        </AuthProvider>
      </OnboardingProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
